import type { Item } from "./types";

export const ITEM_MOVE_DRAG_TYPE = "mine-item";
export const FOLDER_MOVE_DROP_TYPE = "mine-folder";
export const TAG_ADD_DROP_TYPE = "mine-tag";
export const ITEM_MOVE_EXPAND_TARGET_TYPE = "mine-expand-target";

export interface ItemMoveDragItem extends Pick<Item, "id" | "folder_id"> {
  format: string;
  title: string;
  tagIds: string[];
}

export interface ItemMoveDragData {
  kind: typeof ITEM_MOVE_DRAG_TYPE;
  items: ItemMoveDragItem[];
  onMoved?: () => void;
}

export interface FolderMoveDropData {
  kind: typeof FOLDER_MOVE_DROP_TYPE;
  folderId: string;
  folderName: string;
}

export interface TagAddDropData {
  kind: typeof TAG_ADD_DROP_TYPE;
  tagId: string;
  tagName: string;
}

export function isItemMoveDragData(data: unknown): data is ItemMoveDragData {
  if (!data || typeof data !== "object") {
    return false;
  }

  const value = data as Partial<ItemMoveDragData>;
  return (
    value.kind === ITEM_MOVE_DRAG_TYPE &&
    Array.isArray(value.items)
  );
}

export function isFolderMoveDropData(data: unknown): data is FolderMoveDropData {
  if (!data || typeof data !== "object") {
    return false;
  }

  const value = data as Partial<FolderMoveDropData>;
  return (
    value.kind === FOLDER_MOVE_DROP_TYPE &&
    typeof value.folderId === "string" &&
    typeof value.folderName === "string"
  );
}

export function isTagAddDropData(data: unknown): data is TagAddDropData {
  if (!data || typeof data !== "object") {
    return false;
  }

  const value = data as Partial<TagAddDropData>;
  return (
    value.kind === TAG_ADD_DROP_TYPE &&
    typeof value.tagId === "string" &&
    typeof value.tagName === "string"
  );
}
